export const DOWNLOAD_WEIGHT_DISPUTE_ERROR_SUCCESS = "DOWNLOAD_WEIGHT_DISPUTE_ERROR_SUCCESS";
export const DOWNLOAD_WEIGHT_DISPUTE_ERROR_REQUEST = "DOWNLOAD_WEIGHT_DISPUTE_ERROR_REQUEST";
export const DOWNLOAD_WEIGHT_DISPUTE_ERROR_FAILURE = "DOWNLOAD_WEIGHT_DISPUTE_ERROR_FAILURE";
export const DOWNLOAD_WEIGHT_DISPUTE_ERROR_RESET = "DOWNLOAD_WEIGHT_DISPUTE_ERROR_RESET";
export const DownloadWeightDisputeErrorSuccess = (payload) => ({
    type: DOWNLOAD_WEIGHT_DISPUTE_ERROR_SUCCESS,
    payload,
});
export const DownloadWeightDisputeErrorRequest = (payload) => ({
    type: DOWNLOAD_WEIGHT_DISPUTE_ERROR_REQUEST,
    payload,
});
export const DownloadWeightDisputeErrorFailure = (payload) => ({
    type: DOWNLOAD_WEIGHT_DISPUTE_ERROR_FAILURE,
    payload,
});
export const DownloadWeightDisputeErrorReset = () => ({
    type: DOWNLOAD_WEIGHT_DISPUTE_ERROR_RESET,
});
